import React from 'react';
import { LandingV1 } from './pages/LandingV1';
import { LandingV3 } from './pages/LandingV3';
import { LandingV4 } from './pages/LandingV4';
import { LandingV5 } from './pages/LandingV5';
// Reads variant set by index.tsx before render — no re-computation here.
export function App() {
  const variant = (window as any).__abVariant as string;
  switch (variant) {
    case 'V3':
      return <LandingV3 data-id="element-0" />;
    case 'V4':
      return <LandingV4 data-id="element-1" />;
    case 'V5':
      return <LandingV5 data-id="element-2" />;
    case 'V1':
    default:
      return <LandingV1 data-id="element-3" />;
  }
}